<template>
   <div
      :class="{
         'text-white': inverted,
         'flex items-center gap-5': !dashboard,
      }"
   >
      <NuxtLink
         v-if="!dashboard"
         class="__clickable flex shrink-0 items-center gap-1"
         :to="$localePath('/auth/redirect')"
      >
         <Icon
            name="user"
            class="size-5"
            :class="{
               'text-white': inverted,
            }"
         />
         <p class="p-l">{{ $t('common.dashboard') }}</p>
      </NuxtLink>

      <div class="__clickable flex shrink-0 items-center gap-1">
         <Icon
            name="globe-alt"
            class="size-5"
            :class="{
               'text-white': inverted,
            }"
            @click="selectRef?.selectRef?.showPicker()"
         />
         <Select
            v-model="language"
            ref="selectRef"
            class="!p-l"
            :class="{
               '!text-white': inverted,
               '!p-s': dashboard,
            }"
            unstyled
            :options="[
               {
                  id: 'it',
                  value: 'Italiano',
               },
               {
                  id: 'de',
                  value: 'Deutsch',
               },
               {
                  id: 'en',
                  value: 'English',
               },
            ]"
         />
      </div>
   </div>
</template>

<script setup lang="ts">
import type { Select } from '#components'
import { useUpdateUserLocale } from '~/composables/api/mutations/update-user-locale'

type Props = {
   inverted?: boolean
   dashboard?: boolean
}
const props = withDefaults(defineProps<Props>(), {})

const selectRef = ref<InstanceType<typeof Select> | null>(null)

const { locale, setLocale } = useI18n()
const updateUserLocale = useUpdateUserLocale({})
const language = ref(locale.value)

watch(locale, (newLocale) => {
   language.value = newLocale
})

watch(language, async (curr, old) => {
   if (curr === old) return
   await setLocale(curr)
   await updateUserLocale.mutateAsync({ p_locale: curr })
})
</script>
